@import '~style-sheet-helpers/core.less';

.action-button-footer {
  min-width: 150px;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}

.button {
  font-weight: @semi-bold;
  font-size: 13px;
  min-width: 70px;
}

.back-link {
  float: left;
  margin: auto 0;
}
